import { DEFAULT_LANG, MOBILE_WEB_URL } from 'common/constants'
import isMobile from 'is-mobile'
// import withGrant from 'lib/auth/with-grant'
import { GetServerSideProps } from 'next'
// import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Home from 'services/Home/screens/Home'

// export const getStaticProps: GetStaticProps = async ({ locale }) => {
//   return {
//     props: {
//       ...(await serverSideTranslations(locale, ['index'])),
//     },
//   }
// }

// disable server side grant middleware
// export default withGrant(Home)

export const getServerSideProps: GetServerSideProps = async ({
  req,
}) => {
  const userAgent = req.headers['user-agent']
  if (isMobile({ ua: userAgent })) {
    return {
      redirect: {
        destination: `${MOBILE_WEB_URL}`,
        permanent: false,
      },
    }
  }

  return {
    props: {
      pageName: 'Homepage Marketplace',
      lang: req.cookies?.lang || DEFAULT_LANG || 'id',
    },
  }
}

export default Home
